<script lang="ts">
export default {
  name: 'LayoutPage'
};
</script>
<script lang="ts" setup>
import { useStorage } from '@vueuse/core';
import { computed } from 'vue';

import { SideBar } from '#webui/components/sideBar';

const isSidebarOpenStorage = useStorage('sidebarOpen', false);

function handleToggle(opened: boolean) {
  isSidebarOpenStorage.value = opened;
}

const clx = computed(() => ({
  'ml-sidebar-width': isSidebarOpenStorage.value,
  'ml-sidebar-close': !isSidebarOpenStorage.value
}));
</script>

<template>
  <div class="overflow-x-hidden">
    <div class="fixed">
      <SideBar
        :is-open="isSidebarOpenStorage"
        :is-admin="true"
        :is-account-manager="false"
        :is-projects-authorized="false"
        @toggle="handleToggle"
      />
    </div>
    <main class="bg-white h-screen relative mx-3" :class="clx">
      <div class="w-full relative">
        <div class="absolute w-full h-[140%]" />
        <slot name="header" />
        <div class="container isolate mx-auto">
          <div class="container py-2 flex flex-col px-8">
            <slot name="header-content" />
          </div>
        </div>
      </div>

      <div class="container isolate mx-auto">
        <div class="container py-2 flex flex-col px-8">
          <slot />
        </div>
      </div>
    </main>
  </div>
</template>
